import React from 'react';
import { EmploymentStatus } from '../../../types/hr';
const styles: Record<EmploymentStatus, string> = {
  Active: 'bg-emerald-100 text-emerald-800',
  Suspended: 'bg-amber-100 text-amber-800',
  Inactive: 'bg-slate-100 text-slate-700',
  Terminated: 'bg-red-100 text-red-800'
};
export function EmployeeStatusBadge({
  status
}: {
  status: EmploymentStatus;
}) {
  return <span className={`inline-flex rounded-full px-2.5 py-0.5 text-xs font-semibold ${styles[status]}`} data-id="element-777" data-mp="2i3yy7taz13ux">{status}</span>;
}